export default {
  title: 'Mes Alliances',
  alliance: 'Alliance',
  newRequests: "Nouvelles demandes d'Alliances",
  noNewRequests: 'Aucune nouvelle demande',
  activeAlliances: 'Alliances actives',
  noActiveAlliances: 'Aucune alliance active',
  highlightedRole: 'Service mis de l’avant dans votre collaboration',
  chooseRole: 'Choisir un rôle pour cette Alliance',
  developer: 'Développeur',
  designer: 'Designer',
  remove: 'Retirer',
  removingAlliance: "Retrait de l'alliance...",
  requestAlliance: 'Demander une Alliance',
  searchPlaceholder: 'Rechercher un pigiste',
  sendRequest: 'Envoyer une demande',
  sendMyRequest: 'Envoyer ma demande',
  use_credit_and_send: 'Utiliser 1 jeton et envoyer',
  closeFreelancerProfileModal: 'Fermer et retourner aux Alliances',
  requestingAllianceTitle: "Demande d'Alliance",
  allianceMessageForLabel: 'Message pour <bold>{{freelancerName}}</bold>',
  allianceRequestMessagePlaceholder:
    "Ajoutez un message personnalisé pour accompagner votre demande d'Alliance",
  allianceRequestError:
    "Une erreur inconnue est survenue lors de la demande d'Alliance. Veuillez réessayer ou contacter le support.",
  sendingAllianceRequest: 'Envoi de la demande...',
  backToAlliances: 'Retourner à mes Alliances',
  cancelRequest: 'Annuler la demande',
  cancellingRequest: 'Annulation de la demande...',
  allianceRequestSentTitle: 'Demande envoyée',
  allianceRequestSentMessage:
    "<bold>{{freelancerName}}</bold> a bien reçu votre demande. La demande doit être acceptée pour que l'Alliance devienne active.",
  allianceRequestCancelledTitle: 'Demande annulée',
  allianceRequestCancelledMessage: 'La demande à <bold>{{freelancerName}}</bold> a été annulée.',
  allianceRequestCancelledError:
    "Une erreur inconnue est survenue lors de l'annulation de la demande. Veuillez réessayer ou contacter le support.",
  myRequests: "Mes Demandes d'alliances envoyées",
  noRequests: "Aucune demande d'alliance en attente",
  allianceAcceptTile: "Accepter une demande d'Alliance",
  allianceAcceptSubtitle: 'De la part de',
  allianceAcceptRequestMessageLabel: 'Message de {{ requesterName}}',
  allianceAcceptRequestMessage: "Accepter la demande d'Alliance",
  allianceAcceptButtonLabel: 'Utiliser 1 jeton et accepter',
  allianceDeclineTile: "Refuser une demande d'Alliance",
  allianceDeclineButtonLabel: 'Refuser la demande',
  allianceDeclineMessageDescription:
    "Pour refuser la demande d'Alliance de <bold>{{ requesterName }}</bold>, vous devez rédiger une brève explication.",
  allianceDeclineMessagePlaceholder: 'Rédigez une brève explication pour refuser la demande',
  allianceDeclineError: "Une erreur est survenue lors du refus de l'alliance",
  allianceAcceptedTitle: 'Demande acceptée',
  allianceAcceptedMessage:
    'Vous pouvez maintenant participer aux projets de soumission de <bold>{{ requesterName }}</bold> à partir du <bold>Créateur de projet de soumission</bold>.',
  allianceDeclinedTitle: 'Demande refusée',
  allianceDeclinedMessage:
    'Vous avez refusé la demande de <bold>{{ requesterName}}</bold>. Il recevra une notification avec votre message',
  manageQuotes: 'Gérer mes soumissions',
  showRequest: 'Voir la demande',
  noFreelancersDetails:
    'Cela peut arriver si vous avez déjà une alliance avec ou si vous avez déjà envoyé une demande aux pigistes rercherchés.',
  confirmDeleteTitle: 'Confirmer la suppression',
  confirmDeleteMessage: 'Voulez-vous vraiment supprimer votre alliance avec {{name}} ?',
  confirmCancelTitle: "Confirmer l'annulation",
  confirmCancelMessage: "Voulez-vous vraiment annuler votre demande d'alliance avec {{name}} ?",
  confirmCancelButton: "Confirmer l'annulation",
  cancelling: 'Annulation...',
  AddAlliancesTexte: 'Ajouter des alliances à cette soumission',
  allianceRequestInsufficientCredits: "Crédits insuffisants pour envoyer la demande d'alliance",
  confirmDeleteButton: 'Supprimer',
  deleting: 'Suppression...',
  alliances: 'Alliances',
} as const;
